import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../../../projects/accounting/src/public_api";
import { ASCIIPipe } from '../../../../../projects/jv-common/src/public_api';

@Component({
  selector: 'app-deposit',
  templateUrl: './one-time-fees.component.html',
  styleUrls: ['./one-time-fees.component.scss']
})
export class OneTimeFeesComponent implements OnInit {
  Capitals = [];
  CapitalsTemp = [];
  textFilter = '';
  loading = false;
  public TypeLU = {
    "Fee": {
      label: "Phí",
      class: 'text-warning'
    },
    "Deposit": {
      label: 'Đặt cọc',
      class: 'text-primary'
    }
  };
  constructor(
    private api: ApiService,
    private ascii: ASCIIPipe
  ) {

  }
  filter() {
    this.CapitalsTemp = this.Capitals.filter(i => this.ascii.transform(i.Address).toLowerCase().indexOf(this.ascii.transform(this.textFilter).toLowerCase()) > -1);
  }

  ngOnInit() {
    this.loading = true;
    this.api.feeOfOutlets().subscribe(response => {
      if (response.succeed) {

        let buffer: any = response.data;

        buffer.forEach(i => {
          i.Totals = 0;
          if (i.Fees.length > 1) {
            i.Fees.forEach(ii => {
              i.Totals += ii.Total;
            })
          }
        });
        this.loading = false;
        this.Capitals = buffer;
        this.CapitalsTemp = buffer;
      }
    })
  }


  displayName(address) {
    let first = address.split(',')[0];
    return '<b>' + first + '</b><br><small>' + address.substr(first.length + 1) + '</small>';
  }
}
